import { useEffect, useRef, useState } from 'react';

/** Text that becomes an input on click. Enter saves, Escape cancels. */
export function InlineEdit({
  value,
  onSave,
  label,
  className,
  inputMode,
  format = (v) => v,
}: {
  value: string;
  onSave: (v: string) => void;
  label: string;
  className?: string;
  inputMode?: 'text' | 'decimal';
  format?: (v: string) => string;
}) {
  const [editing, setEditing] = useState(false);
  const [draft, setDraft] = useState(value);
  const ref = useRef<HTMLInputElement>(null);

  useEffect(() => {
    if (editing) ref.current?.select();
  }, [editing]);

  if (!editing) {
    return (
      <button
        className={`inline-edit ${className ?? ''}`}
        onClick={() => {
          setDraft(value);
          setEditing(true);
        }}
        aria-label={`Edit ${label}`}
        title={`Edit ${label.toLowerCase()}`}
      >
        {format(value)}
      </button>
    );
  }

  const commit = () => {
    setEditing(false);
    if (draft.trim() && draft !== value) onSave(draft.trim());
  };

  return (
    <input
      ref={ref}
      className={`inline-input ${className ?? ''}`}
      value={draft}
      aria-label={label}
      inputMode={inputMode}
      onChange={(e) => setDraft(e.target.value)}
      onBlur={commit}
      onKeyDown={(e) => {
        if (e.key === 'Enter') commit();
        if (e.key === 'Escape') setEditing(false);
      }}
    />
  );
}
